import { render, staticRenderFns } from "./ChartUsersConnectionsGenders.vue?vue&type=template&id=6f001d13"
import script from "./ChartUsersConnectionsGenders.vue?vue&type=script&lang=js"
export * from "./ChartUsersConnectionsGenders.vue?vue&type=script&lang=js"
import style0 from "./ChartUsersConnectionsGenders.vue?vue&type=style&index=0&id=6f001d13&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports